/* CURRENT CANONICAL Archie visual configurator. All active Archie visual changes go here. */
(function () {
  'use strict';

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function money(value) {
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 }).format(Number(value || 0));
  }

  function init() {
    var root = document.querySelector('[data-adp-archie-visual-configure]');
    var groupsHost = document.querySelector('[data-adp-archie-visual-groups]');
    var detailHero = document.querySelector('[data-adp-archie-configure-hero]');
    var baseStrip = document.querySelector('[data-adp-archie-base-strip]');
    var baseStripText = document.querySelector('[data-adp-archie-base-strip-text]');
    var baseStripDepth = document.querySelector('[data-adp-archie-base-strip-depth]');
    var baseStripPrice = document.querySelector('[data-adp-archie-base-strip-price]');
    var baseStripSku = document.querySelector('[data-adp-archie-base-strip-sku]');
    var baseStripChoices = document.querySelector('[data-adp-archie-base-strip-choices]');
    var baseText = document.querySelector('[data-adp-archie-visual-base]');
    var priceText = document.querySelector('[data-adp-archie-visual-price]');
    var changeBase = document.querySelector('[data-adp-archie-change-base]');
    var continueQuote = document.querySelector('[data-adp-archie-continue-quote]');
    var quoteSection = document.querySelector('.adp-archie-five__quiet--support');
    var describeStage = document.querySelector('.adp-archie-five__quiet--config');
    var manualDetails = document.querySelector('.adp-archie-five__manual');
    var cfg = document.querySelector('[data-adp-archie-configurator]');
    var data = window.ADPArchieConfiguratorData;

    if (!root || !groupsHost || !detailHero || !cfg || !data) return;

    document.documentElement.classList.add('adp-archie-page-active');

    var baseStripAnchor = document.createElement('div');
    baseStripAnchor.className = 'adp-archie-five__base-strip-anchor';
    if (baseStrip && baseStrip.parentNode) baseStrip.parentNode.insertBefore(baseStripAnchor, baseStrip);

    var state = {
      base: null,
      baseValues: null,
      choices: {},
      expanded: {},
      explicitNone: {}
    };

    var GROUPS = [
      { field: 'cabinet_finish', list: 'cabinet_finishes', title: 'Cabinet finish', note: 'Five Archie thermolaminated finishes from the current ADP range.', limit: 8, image: true },
      { field: 'handle', list: 'handles', title: 'Aria handle finish', note: 'Choose one of the six current Archie Aria handle finishes.', limit: 8, image: true },
      { field: 'top_finish', list: 'top_finishes', title: 'Benchtop finish', note: 'Choose No benchtop or any current Archie ADP benchtop finish.', limit: 8, image: true, topOnly: true },
      { field: 'statement_top', list: 'statement_tops', title: 'Benchtop upgrade', note: 'Standard is 40 mm. Statement is 60 or 90 mm; Royale is 60 mm and Durasein only.', limit: 10, image: true, allowNone: true, noneLabel: 'Standard 40mm', topOnly: true },
      { field: 'basin', list: 'basins', title: 'Basin', note: 'ADP basins are sold separately. Double-bowl configurations follow the official multiply rule for each basin.', limit: 8, image: true, allowNone: true, noneLabel: 'No basin supplied' },
      { field: 'waste', list: 'wastes', title: 'Plug & waste', note: 'Chrome is included. Other finishes use current ADP pricing; double bowls follow the official multiply rule.', limit: 10, image: true },
      { field: 'power_point', list: 'power_points', title: 'In-drawer power', note: 'Available only on Archie Door & Drawer bases.', limit: 10, image: true, allowNone: true, noneLabel: 'No power point' },
      { field: 'extra', list: 'extras', title: 'Optional extra', note: 'Official Archie extra: 16mm filler strip, with no cabinet size change.', limit: 10, image: true, allowNone: true, noneLabel: 'No optional extra' },
      { field: 'tap_hole', list: 'tap_holes', title: 'Tap-hole drilling', note: 'Archie order form: 0 tap hole, one hole at 10/12/2 o’clock, or 3 tap holes. For Double Bowl, OZ Bathroom confirms the final drilling layout before supplier release.', limit: 10, image: false, topOnly: true }
    ];
    window.OZBArchieVisualBuild = '2026-10-01-archie-v7';

    function baseLabel(v) {
      if (!v) return '';
      var model = v.model_type === 'door-drawer' ? 'Door & Drawer' : 'All-Door';
      var layout = {centre:'Centre bowl',double:'Double bowl'}[v.layout] || v.layout;
      var top = v.top_mode === 'cabinet-only' ? 'Cabinet only — no ADP benchtop' : 'With benchtop';
      return v.width + ' mm · ' + model + ' · ' + layout + ' · ' + top;
    }

    function syncBaseSummary() {
      if (!state.base) return;
      var depthMm = 500;
      var baseSku = state.base.quote_only ? 'Cabinet only · quote' : (state.base.sku || '—');
      var label = baseLabel(state.base);
      var stripLabel = label + ' · ' + depthMm + ' mm deep';
      if (baseText) baseText.textContent = label;
      if (baseStripText) baseStripText.textContent = stripLabel;
      if (baseStripDepth) baseStripDepth.textContent = depthMm + ' mm';
      if (baseStripPrice) baseStripPrice.textContent = '—';
      if (baseStripSku) baseStripSku.textContent = baseSku;
    }

    function baseForTopMode(topMode) {
      if (!state.base) return null;
      return (data.variants || []).find(function (variant) {
        return variant.model_type === state.base.model_type &&
          Number(variant.width) === Number(state.base.width) &&
          variant.layout === state.base.layout &&
          variant.top_mode === topMode;
      }) || null;
    }

    function available(item) {
      if (!state.base) return true;
      if (item.required_material && item.required_material !== state.choices.top_material) return false;
      if (!item || !item.available_on) return true;
      return item.available_on.indexOf(state.base.model_type + ':' + state.base.width) !== -1;
    }

    function optionPrice(item) {
      if (!item) return 0;
      var key = state.base ? state.base.model_type + ':' + state.base.width : '';
      if (item.price_by_base && Object.prototype.hasOwnProperty.call(item.price_by_base, key)) return Number(item.price_by_base[key] || 0);
      return Number(item.price || 0);
    }

    function currentPrice() {
      var node = cfg.querySelector('[data-live-price]');
      var currentEstimate = node && node.textContent.trim() ? node.textContent.trim() : '—';
      if (priceText) priceText.textContent = currentEstimate;
      if (baseStripPrice) baseStripPrice.textContent = currentEstimate;
      var summary = document.querySelector('[data-adp-archie-order-summary]');
      if (summary && cfg.adpArchieGetSummary) summary.value = cfg.adpArchieGetSummary();
      refreshBaseStrip();
    }

    function tapHoleSummaryVisual() {
      if (!state.base || state.base.top_mode === 'cabinet-only') return '';
      var isDouble = state.base.layout === 'double';
      var leftId = isDouble ? String(state.choices.tap_hole_left || '') : '';
      var rightId = isDouble ? String(state.choices.tap_hole_right || '') : '';
      var singleId = !isDouble ? String(state.choices.tap_hole || '') : '';
      var hasSelection = isDouble ? !!(leftId || rightId) : !!singleId;
      if (!hasSelection) return '';

      function hole(id, cx) {
        if (id === 'one-10') return '<circle cx="' + (cx - 21) + '" cy="31" r="4.2"></circle>';
        if (id === 'one-12') return '<circle cx="' + cx + '" cy="24" r="4.2"></circle>';
        if (id === 'one-2') return '<circle cx="' + (cx + 21) + '" cy="31" r="4.2"></circle>';
        if (id === 'three') return '<circle cx="' + (cx - 21) + '" cy="31" r="4.2"></circle><circle cx="' + cx + '" cy="24" r="4.2"></circle><circle cx="' + (cx + 21) + '" cy="31" r="4.2"></circle>';
        return '';
      }

      var basinMarks = isDouble
        ? '<path d="M90 62 A34 22 0 1 0 22 62 A34 22 0 1 0 90 62 Z M87.2 62 A31.2 19.2 0 1 1 24.8 62 A31.2 19.2 0 1 1 87.2 62 Z"></path>' +
          '<path d="M178 62 A34 22 0 1 0 110 62 A34 22 0 1 0 178 62 Z M175.2 62 A31.2 19.2 0 1 1 112.8 62 A31.2 19.2 0 1 1 175.2 62 Z"></path>'
        : '<path d="M158 62 A58 24 0 1 0 42 62 A58 24 0 1 0 158 62 Z M154.8 62 A54.8 20.8 0 1 1 45.2 62 A54.8 20.8 0 1 1 154.8 62 Z"></path>';
      var holes = isDouble ? hole(leftId, 56) + hole(rightId, 144) : hole(singleId, 100);
      return '<span class="adp-archie-tap-summary-visual" aria-hidden="true"><svg viewBox="0 0 200 104" focusable="false">' +
        '<rect class="adp-archie-tap-summary-visual__cabinet" x="12" y="16" width="176" height="80" rx="3"></rect>' +
        '<rect class="adp-archie-tap-summary-visual__top" x="8" y="8" width="184" height="78" rx="4"></rect>' +
        '<g class="adp-archie-tap-summary-visual__basins" fill-rule="evenodd">' + basinMarks + '</g>' +
        '<g class="adp-archie-tap-summary-visual__holes">' + holes + '</g>' +
        '</svg></span>';
    }

    function refreshBaseStrip() {
      if (!baseStripChoices || !state.base) return;
      var hasPowerChoice = (data.power_points || []).some(available);
      var fields = [
        {field:'cabinet_finish', list:'cabinet_finishes', label:'Cabinet'},
        {field:'handle', list:'handles', label:'Handle'},
        {field:'top_finish', list:'top_finishes', label:'Top'},
        {field:'statement_top', list:'statement_tops', label:'Benchtop upgrade', noneLabel:'Standard 40mm'},
        {field:'basin', list:'basins', label:'Basin'},
        {field:'waste', list:'wastes', label:'Waste'},
        {field:'power_point', list:'power_points', label:'Power'},
        {field:'extra', list:'extras', label:'Extra'},
        {field:'tap_hole_summary', label:'Tap holes', special:true}
      ].filter(function (entry) {
        return entry.field !== 'power_point' || hasPowerChoice;
      });
      baseStripChoices.innerHTML = fields.map(function (entry) {
        if (entry.special && entry.field === 'tap_hole_summary') {
          var tapVisual = tapHoleSummaryVisual();
          if (!tapVisual) return '<span class="adp-archie-five__base-choice adp-archie-five__base-choice--placeholder" data-adp-archie-base-choice-placeholder="tap_hole_summary" aria-hidden="true"><span class="adp-archie-five__base-choice-none"></span><span></span></span>';
          return '<span class="adp-archie-five__base-choice adp-archie-five__base-choice--tap-summary" data-adp-archie-base-choice="tap_hole_summary" aria-label="Tap holes">' + tapVisual + '<span>Tap holes</span></span>';
        }
        var value = state.choices[entry.field];
        if (!value) {
          if (!state.explicitNone[entry.field]) return '<span class="adp-archie-five__base-choice adp-archie-five__base-choice--placeholder" data-adp-archie-base-choice-placeholder="' + esc(entry.field) + '" aria-hidden="true"><span class="adp-archie-five__base-choice-none"></span><span></span></span>';
          var noneLabel = entry.noneLabel || (entry.field === 'top_finish' ? 'No benchtop' : entry.field === 'basin' ? 'No basin supplied' : entry.field === 'power_point' ? 'No power point' : 'None');
          return '<span class="adp-archie-five__base-choice adp-archie-five__base-choice--none" data-adp-archie-base-choice="' + esc(entry.field) + '"><span class="adp-archie-five__base-choice-none" aria-hidden="true">None</span><span>' + esc(noneLabel) + '</span></span>';
        }
        var item = (data[entry.list] || []).find(function (candidate) { return String(candidate.id) === String(value); });
        if (!item) return '';
        var isDouble = state.base.layout === 'double';
        var thumbnail = '';
        var choiceClass = '';
        var choiceText = item.name;
        if (entry.field === 'statement_top') choiceText = 'Benchtop upgrade · ' + item.name;

        if (item.image && entry.field === 'basin' && isDouble) {
          thumbnail = '<span class="adp-archie-five__base-choice-visuals adp-archie-five__base-choice-visuals--double"><img src="' + esc(item.image) + '" alt="" loading="lazy"><img src="' + esc(item.image) + '" alt="" loading="lazy"></span>';
          choiceClass = ' adp-archie-five__base-choice--double-basin';
          choiceText = '2 × ' + item.name;
        } else if (item.image && entry.field === 'waste' && isDouble) {
          thumbnail = '<span class="adp-archie-five__base-choice-visuals adp-archie-five__base-choice-visuals--double-waste"><img src="' + esc(item.image) + '" alt="" loading="lazy"><img src="' + esc(item.image) + '" alt="" loading="lazy"></span>';
          choiceClass = ' adp-archie-five__base-choice--double-waste';
          choiceText = '2 × ' + item.name;
        } else if (item.image) {
          thumbnail = '<img src="' + esc(item.image) + '" alt="" loading="lazy">';
        }
        return '<span class="adp-archie-five__base-choice' + choiceClass + '" data-adp-archie-base-choice="' + esc(entry.field) + '">' + thumbnail + '<span>' + esc(choiceText) + '</span></span>';
      }).join('');
      baseStrip.classList.toggle('has-visual-choices', baseStripChoices.textContent.trim().length > 0);
      updateBaseStripPin();
    }

    function updateBaseStripPin() {
      if (!baseStrip || !baseStripAnchor || !state.base || baseStrip.hidden || baseStrip.classList.contains('is-handoff-target')) return;
      var anchor = baseStripAnchor.getBoundingClientRect();
      var rootBounds = root.getBoundingClientRect();
      var pin = anchor.top <= 16 && rootBounds.bottom > baseStrip.offsetHeight + 24;
      if (pin) {
        if (!baseStrip.classList.contains('is-pinned')) baseStripAnchor.style.height = baseStrip.offsetHeight + 'px';
        var fixedBounds = baseStripAnchor.getBoundingClientRect();
        baseStrip.style.setProperty('--archie-base-strip-left', fixedBounds.left + 'px');
        baseStrip.style.setProperty('--archie-base-strip-width', fixedBounds.width + 'px');
        baseStrip.classList.add('is-pinned');
      } else {
        baseStrip.classList.remove('is-pinned');
        baseStrip.style.removeProperty('--archie-base-strip-left');
        baseStrip.style.removeProperty('--archie-base-strip-width');
        baseStripAnchor.style.height = '';
      }
    }

    function captureChoiceFlight(option) {
      if (!option) return null;
      var image = option.querySelector('img');
      var source = image || option.querySelector('.adp-archie-visual-option__image--none');
      if (!source) return null;
      var start = source.getBoundingClientRect();
      return {
        kind: image ? 'image' : 'none',
        src: image ? (image.currentSrc || image.src) : '',
        text: image ? '' : source.textContent.trim(),
        left:start.left,
        top:start.top,
        width:start.width,
        height:start.height
      };
    }

    function animateChoiceToStrip(flightData, field) {
      if (!flightData || !baseStrip) return;
      window.requestAnimationFrame(function () {
        var choice = baseStrip.querySelector('[data-adp-archie-base-choice="' + field + '"]');
        var target = choice && (flightData.kind === 'image' ? choice.querySelector('img') : choice.querySelector('.adp-archie-five__base-choice-none'));
        if (!target) return;
        var end = target.getBoundingClientRect();
        var flight = flightData.kind === 'image' ? document.createElement('img') : document.createElement('div');
        flight.className = 'adp-archie-choice-flight' + (flightData.kind === 'none' ? ' adp-archie-choice-flight--none' : '');
        if (flightData.kind === 'image') {
          flight.src = flightData.src;
          flight.alt = '';
        } else {
          flight.textContent = flightData.text || 'None';
        }
        flight.style.left = flightData.left + 'px';
        flight.style.top = flightData.top + 'px';
        flight.style.width = flightData.width + 'px';
        flight.style.height = flightData.height + 'px';
        document.body.appendChild(flight);
        window.requestAnimationFrame(function () {
          flight.style.left = end.left + 'px';
          flight.style.top = end.top + 'px';
          flight.style.width = end.width + 'px';
          flight.style.height = end.height + 'px';
          flight.style.opacity = '.18';
        });
        window.setTimeout(function () { flight.remove(); }, 620);
      });
    }

    function previewModal() {
      var modal = document.querySelector('[data-adp-archie-visual-modal]');
      if (modal) return modal;
      modal = document.createElement('div');
      modal.className = 'adp-archie-visual-modal';
      modal.hidden = true;
      modal.setAttribute('data-adp-archie-visual-modal', '');
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML = '<div class="adp-archie-visual-modal__backdrop" data-adp-archie-visual-modal-close></div><div class="adp-archie-visual-modal__panel"><button type="button" class="adp-archie-visual-modal__close" data-adp-archie-visual-modal-close aria-label="Close material preview">×</button><img data-adp-archie-visual-modal-image alt=""><p data-adp-archie-visual-modal-label></p></div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-adp-archie-visual-modal-close]')) modal.hidden = true;
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') modal.hidden = true;
      });
      return modal;
    }

    function openPreview(src, label) {
      var modal = previewModal();
      var image = modal.querySelector('[data-adp-archie-visual-modal-image]');
      var caption = modal.querySelector('[data-adp-archie-visual-modal-label]');
      image.src = src;
      image.alt = label;
      caption.textContent = label;
      modal.hidden = false;
      modal.querySelector('.adp-archie-visual-modal__close').focus();
    }

    function payloadFor(nextChoices) {
      var payload = Object.assign({}, state.baseValues || {}, nextChoices || {});
      ['step','confirmed','expanded'].forEach(function (key) { delete payload[key]; });
      if (payload.top_finish) {
        var top = data.top_finishes.find(function (item) { return String(item.id) === String(payload.top_finish); });
        if (top) payload.top_material = top.material;
      }
      if (state.base && state.base.top_mode === 'cabinet-only') {
        delete payload.top_finish;
        delete payload.top_material;
        delete payload.statement_top;
        delete payload.tap_hole;
        delete payload.tap_hole_left;
        delete payload.tap_hole_right;
      }
      return payload;
    }

    function applyChoice(field, rawValue) {
      var next = Object.assign({}, state.choices);
      var selectingNone = rawValue === '__none__';
      if (selectingNone) next[field] = null;
      else next[field] = rawValue;

      if (field === 'top_finish') {
        var top = data.top_finishes.find(function (item) { return String(item.id) === String(rawValue); });
        if (top) next.top_material = top.material;
        var upgrade = data.statement_tops.find(function (item) { return String(item.id) === String(next.statement_top); });
        if (upgrade && upgrade.required_material && upgrade.required_material !== next.top_material) next.statement_top = null;
      }

      var applied = cfg.adpArchieApplyRequirements(payloadFor(next));
      if (!applied || !applied.ok) {
        var message = applied && applied.errors ? applied.errors.join(' ') : 'That choice could not be applied.';
        root.setAttribute('data-visual-error', message);
        var error = root.querySelector('[data-adp-archie-visual-error]');
        if (error) error.textContent = message;
        return false;
      }

      root.removeAttribute('data-visual-error');
      var errorNode = root.querySelector('[data-adp-archie-visual-error]');
      if (errorNode) errorNode.textContent = '';
      state.choices = cfg.adpArchieGetState ? cfg.adpArchieGetState() : next;
      state.explicitNone[field] = selectingNone;
      renderGroups();
      currentPrice();
      return true;
    }

    function optionMeta(group, item) {
      if (!item) return '';
      if (item.out_of_stock) return 'Out of stock — contact us for availability';
      if (group.field === 'top_finish') return (item.material || '') + (item.adjustment_percent ? ' · +' + item.adjustment_percent + '%' : ' · included');
      if (group.field === 'waste' || group.field === 'power_point' || group.field === 'statement_top' || group.field === 'basin' || group.field === 'extra') {
        var count = item.multiply_by_basin_count && state.base.layout === 'double' ? 2 : 1;
        var price = optionPrice(item) * count;
        return (item.basin_type ? item.basin_type + ' · ' : '') + (price > 0 ? '+' + money(price) + (count === 2 ? ' for 2' : '') : 'Included');
      }
      return '';
    }

    function tapHoleOptionVisual(item) {
      var id = item && item.id ? String(item.id) : '';
      var basinOutline = '<path data-tap-basin-outline="solid" fill="#483d33" fill-opacity=".24" fill-rule="evenodd" stroke="none" d="M126 64 A46 27 0 1 0 34 64 A46 27 0 1 0 126 64 Z M123.2 64 A43.2 24.2 0 1 1 36.8 64 A43.2 24.2 0 1 1 123.2 64 Z"></path>';
      var holes = '';
      if (id === 'one-10') holes = '<circle cx="49" cy="31" r="4.3" fill="#6a4b39"></circle>';
      else if (id === 'one-12') holes = '<circle cx="80" cy="24" r="4.3" fill="#6a4b39"></circle>';
      else if (id === 'one-2') holes = '<circle cx="111" cy="31" r="4.3" fill="#6a4b39"></circle>';
      else if (id === 'three') holes = '<circle cx="49" cy="31" r="4.3" fill="#6a4b39"></circle><circle cx="80" cy="24" r="4.3" fill="#6a4b39"></circle><circle cx="111" cy="31" r="4.3" fill="#6a4b39"></circle>';
      return '<span class="adp-archie-tap-hole-option-visual" aria-hidden="true">' +
        '<svg viewBox="0 0 160 104" focusable="false">' +
          '<rect class="adp-archie-tap-hole-option-visual__top" x="8" y="8" width="144" height="88" rx="4"></rect>' +
          '<g class="adp-archie-tap-hole-option-visual__marks">' + basinOutline + holes + '</g>' +
        '</svg>' +
      '</span>';
    }

    function doubleTapHoleOptionVisual(item, side) {
      var id = item && item.id ? String(item.id) : '';
      var leftActive = side === 'left';
      var leftFill = leftActive ? '.34' : '.12';
      var rightFill = leftActive ? '.12' : '.34';
      var leftRing = '<path fill="#483d33" fill-opacity="' + leftFill + '" fill-rule="evenodd" stroke="none" d="M90 65 A34 23 0 1 0 22 65 A34 23 0 1 0 90 65 Z M87.2 65 A31.2 20.2 0 1 1 24.8 65 A31.2 20.2 0 1 1 87.2 65 Z"></path>';
      var rightRing = '<path fill="#483d33" fill-opacity="' + rightFill + '" fill-rule="evenodd" stroke="none" d="M178 65 A34 23 0 1 0 110 65 A34 23 0 1 0 178 65 Z M175.2 65 A31.2 20.2 0 1 1 112.8 65 A31.2 20.2 0 1 1 175.2 65 Z"></path>';
      var cx = side === 'left' ? 56 : 144;
      var hole = '';
      if (id === 'one-10') hole = '<circle cx="' + (cx - 21) + '" cy="34" r="4.2" fill="#6a4b39"></circle>';
      else if (id === 'one-12') hole = '<circle cx="' + cx + '" cy="27" r="4.2" fill="#6a4b39"></circle>';
      else if (id === 'one-2') hole = '<circle cx="' + (cx + 21) + '" cy="34" r="4.2" fill="#6a4b39"></circle>';
      else if (id === 'three') hole = '<circle cx="' + (cx - 21) + '" cy="34" r="4.2" fill="#6a4b39"></circle><circle cx="' + cx + '" cy="27" r="4.2" fill="#6a4b39"></circle><circle cx="' + (cx + 21) + '" cy="34" r="4.2" fill="#6a4b39"></circle>';
      return '<span class="adp-archie-double-tap-option-visual" aria-hidden="true">' +
        '<svg viewBox="0 0 200 104" focusable="false">' +
          '<rect class="adp-archie-tap-hole-option-visual__top" x="8" y="8" width="184" height="88" rx="4"></rect>' +
          '<g>' + leftRing + rightRing + hole + '</g>' +
        '</svg>' +
      '</span>';
    }

    function renderDoubleTapHoleGroup(group) {
      var options = (data.tap_holes || []).filter(available);
      var leftOrder = ['none','one-10','one-12','one-2','three'];
      var rightOrder = ['one-2','none','one-10','one-12','three'];

      function sideBlock(side, label, order) {
        var field = 'tap_hole_' + side;
        var selected = state.choices[field];
        var ordered = order.map(function (id) {
          return options.find(function (item) { return String(item.id) === id; });
        }).filter(Boolean);
        return '<div class="adp-archie-double-tap__side" data-double-tap-side="' + side + '">' +
          '<h3>' + label + '</h3><div class="adp-archie-double-tap__options">' +
          ordered.map(function (item, index) {
            var active = String(selected || '') === String(item.id);
            return '<button type="button" class="adp-archie-visual-option adp-archie-double-tap__option' + (active ? ' is-selected' : '') + '" data-double-tap-field="' + field + '" data-double-tap-value="' + esc(item.id) + '" data-mirror-row="' + index + '" aria-pressed="' + (active ? 'true' : 'false') + '">' +
              doubleTapHoleOptionVisual(item, side) +
              '<span class="adp-archie-visual-option__copy"><strong>' + esc(item.name) + '</strong></span></button>';
          }).join('') + '</div></div>';
      }

      return '<section class="adp-archie-visual-group adp-archie-visual-group--double-tap" data-visual-group="tap_hole">' +
        '<div class="adp-archie-visual-group__heading"><div><span>' + esc(group.title) + '</span><p>Choose left and right basin drilling separately. Each row is physically mirrored across the vanity centreline.</p></div></div>' +
        '<div class="adp-archie-double-tap">' +
          sideBlock('left', 'Left basin', leftOrder) +
          sideBlock('right', 'Right basin', rightOrder) +
        '</div></section>';
    }

    function renderOption(group, item, none) {
      var value = none ? '__none__' : String(item.id);
      var selected = none ? !!state.explicitNone[group.field] : String(state.choices[group.field]) === value;
      var label = none ? group.noneLabel : item.name;
      var image = group.image && !none && item.image ? item.image : '';
      var meta = none ? '' : optionMeta(group, item);
      var tapVisual = group.field === 'tap_hole' && !none ? tapHoleOptionVisual(item) : '';
      var visual = tapVisual || (image
        ? '<span class="adp-archie-visual-option__image"><img loading="lazy" src="' + esc(image) + '" alt="' + esc(label) + '"></span>'
        : (none && group.image ? '<span class="adp-archie-visual-option__image adp-archie-visual-option__image--none" aria-hidden="true"><span>None</span></span>' : ''));
      var preview = image ? '<button type="button" class="adp-archie-visual-option__preview" data-visual-preview-src="' + esc(image) + '" data-visual-preview-label="' + esc(label) + '" aria-label="View ' + esc(label) + ' larger">+</button>' : '';
      var hasVisualSlot = !!tapVisual || !!image || (none && group.image);
      return '<div class="adp-archie-visual-option-wrap"><button type="button" class="adp-archie-visual-option' + (!hasVisualSlot ? ' adp-archie-visual-option--text' : '') + (selected ? ' is-selected' : '') + '" data-visual-field="' + esc(group.field) + '" data-visual-value="' + esc(value) + '" aria-pressed="' + (selected ? 'true' : 'false') + '"' + (!none && item.out_of_stock ? ' disabled' : '') + '>' +
        visual + '<span class="adp-archie-visual-option__copy"><strong>' + esc(label) + '</strong>' + (meta ? '<small>' + esc(meta) + '</small>' : '') + '</span></button>' + preview + '</div>';
    }

    function renderNoBenchtopOption() {
      var selected = state.base && state.base.top_mode === 'cabinet-only';
      return '<div class="adp-archie-visual-option-wrap"><button type="button" class="adp-archie-visual-option' + (selected ? ' is-selected' : '') + '" data-adp-archie-no-benchtop aria-pressed="' + (selected ? 'true' : 'false') + '"><span class="adp-archie-visual-option__image adp-archie-visual-option__image--none" aria-hidden="true"><span>No top</span></span><span class="adp-archie-visual-option__copy"><strong>No benchtop</strong><small>Cabinet only</small></span></button></div>';
    }

    function renderGroup(group) {
      if (group.topOnly && group.field !== 'top_finish' && state.base && state.base.top_mode === 'cabinet-only') return '';
      if (group.field === 'tap_hole' && state.base && state.base.layout === 'double') return renderDoubleTapHoleGroup(group);
      var options = (data[group.list] || []).filter(available);
      if (group.field === 'power_point' && options.length === 0) return '';
      var showAll = group.field === 'top_finish' || !!state.expanded[group.field];
      var limit = group.limit || options.length;
      var shown = showAll ? options : options.slice(0, limit);
      var optionHtml = '';
      if (group.field === 'top_finish') optionHtml += renderNoBenchtopOption();
      else if (group.allowNone) optionHtml += renderOption(group, null, true);
      optionHtml += shown.map(function (item) { return renderOption(group, item, false); }).join('');
      var hasMore = !showAll && options.length > shown.length;
      var previewHtml = '';
      if (hasMore && group.field === 'cabinet_finish') {
        previewHtml = '<div class="adp-archie-visual-group__preview" aria-hidden="true" inert>' + options.slice(limit, limit * 2).map(function (item) { return renderOption(group, item, false); }).join('') + '</div>';
      }
      var moreLabel = group.field === 'cabinet_finish' ? 'View all ' + options.length + ' finishes' : 'View all ' + options.length;
      var more = hasMore ? '<button type="button" class="adp-archie-visual-configure__more" data-visual-expand="' + esc(group.field) + '">' + moreLabel + '</button>' : '';
      var less = showAll && options.length > limit ? '<button type="button" class="adp-archie-visual-configure__more" data-visual-collapse="' + esc(group.field) + '">Show less</button>' : '';
      var choiceCount = group.field === 'top_finish' ? options.length + 1 : options.length;
      var optionsBlock = '<div class="adp-archie-visual-group__options">' + optionHtml + '</div>' + previewHtml;
      optionsBlock += more + less;
      return '<section class="adp-archie-visual-group' + (previewHtml ? ' has-collapsed-preview' : '') + '" data-visual-group="' + esc(group.field) + '"><div class="adp-archie-visual-group__heading"><div><span>' + esc(group.title) + '</span><p>' + esc(group.note) + '</p></div><em>' + choiceCount + ' choices</em></div>' + optionsBlock + '</section>';
    }

    function renderGroups() {
      if (!state.base) return;
      groupsHost.innerHTML = GROUPS.map(renderGroup).join('') + '<p class="adp-archie-visual-configure__error" data-adp-archie-visual-error aria-live="polite"></p>';
    }

    function selectBase(detail) {
      if (!detail || !detail.variant) return;
      state.base = detail.variant;
      state.baseValues = Object.assign({}, {
        mounting: 'wall-hung',
        requested_depth: 'full-depth',
        model_type: detail.variant.model_type,
        width: detail.variant.width,
        layout: detail.variant.layout,
        top_mode: detail.variant.top_mode
      }, detail.values || {});
      var reset = {
        cabinet_finish:null,
        handle:null,
        top_material:null,
        top_finish:null,
        basin:null,
        waste:null,
        power_point:null,
        extra:null,
        statement_top:null,
        tap_hole:null,
        tap_hole_left:null,
        tap_hole_right:null,
        customer_notes:''
      };
      cfg.adpArchieApplyRequirements(Object.assign({}, reset, state.baseValues));
      state.choices = cfg.adpArchieGetState ? cfg.adpArchieGetState() : {};
      state.expanded = {};
      state.explicitNone = {};
      if (state.base.top_mode === 'cabinet-only') state.explicitNone.top_finish = true;
      syncBaseSummary();
      if (baseStrip) {
        baseStrip.hidden = false;
        baseStrip.classList.add('is-handoff-target');
      }
      root.hidden = false;
      document.documentElement.classList.add('adp-archie-configure-active');
      renderGroups();
      currentPrice();

    }

    function switchTopMode(topMode) {
      if (!state.base || state.base.top_mode === topMode) return true;
      var nextBase = baseForTopMode(topMode);
      if (!nextBase) {
        var missing = root.querySelector('[data-adp-archie-visual-error]');
        if (missing) missing.textContent = 'That benchtop supply option is not available for this base configuration.';
        return false;
      }
      var result = cfg.adpArchieApplyRequirements({top_mode:topMode});
      var error = root.querySelector('[data-adp-archie-visual-error]');
      if (!result || !result.ok) {
        if (error) error.textContent = result && result.errors ? result.errors.join(' ') : 'That base change could not be applied.';
        return false;
      }
      if (error) error.textContent = '';
      state.base = nextBase;
      state.baseValues = Object.assign({}, state.baseValues || {}, {top_mode:topMode});
      if (topMode === 'cabinet-only') {
        ['top_finish','top_material','statement_top','tap_hole','tap_hole_left','tap_hole_right'].forEach(function (field) { delete state.baseValues[field]; });
      }
      state.choices = cfg.adpArchieGetState ? cfg.adpArchieGetState() : Object.assign({}, state.choices, {top_mode:topMode});
      state.expanded.top_finish = false;
      state.explicitNone.top_finish = topMode === 'cabinet-only';
      syncBaseSummary();
      renderGroups();
      currentPrice();
      return true;
    }

    groupsHost.addEventListener('click', function (event) {
      var noBenchtop = event.target.closest('[data-adp-archie-no-benchtop]');
      if (noBenchtop) {
        var noTopFlight = captureChoiceFlight(noBenchtop);
        if (switchTopMode('cabinet-only')) {
          state.explicitNone.top_finish = true;
          refreshBaseStrip();
          animateChoiceToStrip(noTopFlight, 'top_finish');
        }
        return;
      }
      var doubleTap = event.target.closest('[data-double-tap-field]');
      if (doubleTap) {
        var tapField = doubleTap.dataset.doubleTapField;
        var tapValues = {};
        tapValues[tapField] = doubleTap.dataset.doubleTapValue;
        var tapResult = cfg.adpArchieApplyRequirements(tapValues);
        var tapError = root.querySelector('[data-adp-archie-visual-error]');
        if (tapError) tapError.textContent = tapResult.ok ? '' : tapResult.errors.join(' ');
        if (tapResult.ok) {
          state.choices = cfg.adpArchieGetState();
          renderGroups();
          currentPrice();
        }
        return;
      }
      var option = event.target.closest('[data-visual-field]');
      if (option) {
        var field = option.dataset.visualField;
        var flightData = captureChoiceFlight(option);
        if (field === 'top_finish' && state.base && state.base.top_mode === 'cabinet-only' && !switchTopMode('standard-top')) return;
        if (field === 'top_finish') state.explicitNone.top_finish = false;
        if (applyChoice(field, option.dataset.visualValue)) animateChoiceToStrip(flightData, field);
        return;
      }
      if (event.target.closest('[data-adp-archie-change-base-inline]')) {
        if (changeBase) changeBase.click();
        return;
      }
      var preview = event.target.closest('[data-visual-preview-src]');
      if (preview) {
        openPreview(preview.dataset.visualPreviewSrc, preview.dataset.visualPreviewLabel);
        return;
      }
      var expand = event.target.closest('[data-visual-expand]');
      if (expand) {
        state.expanded[expand.dataset.visualExpand] = true;
        renderGroups();
        return;
      }
      var collapse = event.target.closest('[data-visual-collapse]');
      if (collapse) {
        state.expanded[collapse.dataset.visualCollapse] = false;
        renderGroups();
        return;
      }
    });

    groupsHost.addEventListener('change', function (event) {
      var input = event.target.closest('[data-order-field]');
      if (!input) return;
      var field = input.dataset.orderField;
      var next = Object.assign({}, state.choices);
      next[field] = input.type === 'number' ? (input.value === '' ? null : Number(input.value)) : (input.value || null);
      // Pass only business fields; the engine snapshot also contains UI state.
      var result = cfg.adpArchieApplyRequirements(Object.fromEntries([[field, next[field]]]));
      if (!result.ok) {
        root.querySelector('[data-adp-archie-visual-error]').textContent = result.errors.join(' ');
        if (continueQuote) continueQuote.disabled = true;
        return;
      }
      if (continueQuote) continueQuote.disabled = false;
      state.choices = cfg.adpArchieGetState();
      renderGroups();
      currentPrice();
    });

    groupsHost.addEventListener('input', function (event) {
      var input = event.target.closest('[data-order-field]');
      if (!input) return;
      var values = {};
      values[input.dataset.orderField] = input.type === 'number' ? (input.value === '' ? null : Number(input.value)) : input.value;
      var result = cfg.adpArchieApplyRequirements(values);
      root.querySelector('[data-adp-archie-visual-error]').textContent = result.ok ? '' : result.errors.join(' ');
      if (continueQuote) continueQuote.disabled = !result.ok;
      if (result.ok) {
        state.choices = cfg.adpArchieGetState();
        currentPrice();
      }
    });

    if (changeBase) changeBase.addEventListener('click', function () {
      root.hidden = true;
      if (baseStrip) baseStrip.hidden = true;
      if (baseStrip) baseStrip.classList.remove('is-handoff-target');
      if (window.ADPArchieClearBaseHandoff) window.ADPArchieClearBaseHandoff();
      if (describeStage) describeStage.classList.remove('is-base-selected');
      document.documentElement.classList.remove('adp-archie-configure-active');
      document.querySelectorAll('.adp-archie-natural-language__card').forEach(function (card) { card.classList.remove('is-selected','is-not-selected'); });
      document.querySelectorAll('[data-nl-use]').forEach(function (button) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-selected');
      });
      if (manualDetails) manualDetails.open = false;
      window.requestAnimationFrame(function () { describeStage.scrollIntoView({ block: 'start' }); });
    });

    if (continueQuote) continueQuote.addEventListener('click', function () {
      currentPrice();
      if (quoteSection) quoteSection.scrollIntoView({ block: 'start' });
    });

    var copySummary = document.querySelector('[data-adp-archie-copy-summary]');
    if (copySummary) copySummary.addEventListener('click', function () {
      currentPrice();
      var summary = document.querySelector('[data-adp-archie-order-summary]');
      if (summary && navigator.clipboard) navigator.clipboard.writeText(summary.value).then(function () {
        copySummary.textContent = 'Configuration copied';
      }).catch(function () { summary.focus(); summary.select(); });
    });

    document.addEventListener('adp:archie:base-selected', function (event) { selectBase(event.detail); });

    window.addEventListener('resize', updateBaseStripPin);
    document.addEventListener('scroll', updateBaseStripPin, true);

    var priceNode = cfg.querySelector('[data-live-price]');
    if (priceNode && window.MutationObserver) new MutationObserver(currentPrice).observe(priceNode, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
